export default {
  path: "/personalCenter",
  meta: { name: "个人信息总后台" },
  component: () => import("@/views/personalCenter/index.vue"),
  children: [
    {
      path: "chongzhihetixian",
      meta: { name: "充值和提现" },
      component: () => import("@/views/personalCenter/content.vue"),
      children: [
        {
          path: "suobichongzhi",
          meta: { name: "缩币充值" },
          component: () =>
            import(
              "@/views/personalCenter/chongzhihetixian/suobi_chongzhi.vue"
            ),
        },
        {
          path: "chongzhijilu",
          meta: { name: "充值记录" },
          component: () =>
            import("@/views/personalCenter/chongzhihetixian/chongzhi_jilu.vue"),
        },
        {
          path: "xiaofeijilu",
          meta: { name: "消费记录" },
          component: () =>
            import("@/views/personalCenter/chongzhihetixian/xiaofei_jilu.vue"),
        },
        {
          path: "shourutongji",
          meta: { name: "收入统计" },
          component: () =>
            import("@/views/personalCenter/chongzhihetixian/shouru_tongji.vue"),
        },
        {
          path: "shengqingtixian",
          meta: { name: "申请提现" },
          component: () =>
            import(
              "@/views/personalCenter/chongzhihetixian/shengqing_tixian.vue"
            ),
        },
        {
          path: "tixianjilu",
          meta: { name: "提现记录" },
          component: () =>
            import("@/views/personalCenter/chongzhihetixian/tixian_jilu.vue"),
        },
        {
          path: "zonghetongji",
          meta: { name: "综合统计" },
          component: () =>
            import("@/views/personalCenter/chongzhihetixian/zonghe_tongji.vue"),
        },
      ],
    },
    {
      path: "userinfo",
      meta: { name: "个人信息" },
      component: () => import("@/views/personalCenter/content.vue"),
      children: [
        {
          path: "yhzx",
          meta: { name: "用户中心" },
          component: () => import("@/views/personalCenter/user/yhzx"),
        },
        {
          path: "smrz",
          meta: { name: "实名认证" },
          component: () => import("@/views/personalCenter/user/shiming"),
        },
        {
          path: "edit",
          meta: { name: "编辑资料" },
          component: () => import("@/views/personalCenter/user/edit"),
        },
        {
          path: "mess",
          meta: { name: "站内信" },
          component: () => import("@/views/personalCenter/user/mess"),
        },
        {
          path: "xitongMess",
          meta: { name: "系统消息" },
          component: () => import("@/views/personalCenter/user/xitongMess"),
        },
        {
          path: "liuyan",
          meta: { name: "留言反馈" },
          component: () => import("@/views/personalCenter/user/liuyan"),
        },
      ],
    },
    {
      path: "hangjiaguanli",
      meta: { name: "行家管理" },
      component: () => import("@/views/personalCenter/content.vue"),
      children: [
        {
          path: "apply_sss",
          meta: { name: "申请缩水师" },
          component: () =>
            import("@/views/personalCenter/hangjiaguanli/apply_sss"),
        },
        {
          path: "sss_zhuanlan",
          meta: { name: "缩水师专栏" },
          component: () =>
            import("@/views/personalCenter/hangjiaguanli/sss_zhuanlan"),
        },
        {
          path: "sss_chengji",
          meta: { name: "缩水师成绩" },
          component: () =>
            import("@/views/personalCenter/hangjiaguanli/sss_chengji"),
        },
        {
          path: "apply_jqs",
          meta: { name: "申请技巧师" },
          component: () =>
            import("@/views/personalCenter/hangjiaguanli/apply_jqs"),
        },
        {
          path: "jqs_zhuanlan",
          meta: { name: "技巧师专栏" },
          component: () =>
            import("@/views/personalCenter/hangjiaguanli/jqs_zhuanlan"),
        },
        {
          path: "jqs_chengji",
          meta: { name: "技巧师成绩" },
          component: () =>
            import("@/views/personalCenter/hangjiaguanli/jqs_chengji"),
        },
      ],
    },
    {
      path: "sss_yc",
      meta: { name: "我的缩水师预测" },
      component: () => import("@/views/personalCenter/content.vue"),
      children: [
        {
          path: "ssq_sss_yc",
          meta: { name: "双色球缩水师预测" },
          component: () => import("@/views/personalCenter/sss_yuce/ssq_sss_yc"),
        },
        {
          path: "dlt_sss_yc",
          meta: { name: "大乐透缩水师预测" },
          component: () => import("@/views/personalCenter/sss_yuce/dlt_sss_yc"),
        },
        {
          path: "fcsd_sss_yc",
          meta: { name: "3D缩水师预测" },
          component: () =>
            import("@/views/personalCenter/sss_yuce/fcsd_sss_yc"),
        },
        {
          path: "pls_sss_yc",
          meta: { name: "排三缩水师预测" },
          component: () => import("@/views/personalCenter/sss_yuce/pls_sss_yc"),
        },
        {
          path: "sss_yc_mx",
          meta: { name: "缩水师预测明细" },
          component: () => import("@/views/personalCenter/sss_yuce/sss_yc_mx"),
        },
        // {
        //     meta: { name: '闲置/定制EXCEL不容错条件试点区' },
        //     component: () => import('@/views/personalCenter/sss_yuce/sss_yc_mx'),
        // },
      ],
    },
    {
      path: "jqs_fabu",
      meta: { name: "我的技巧师发布" },
      component: () => import("@/views/personalCenter/content.vue"),
      children: [
        {
          path: "no_room_for_error",
          meta: { name: "不容错条件试点区" },
          component: () =>
            import(
              "@/views/personalCenter/jqs_fabu/no_room_for_error/index.vue"
            ),
        },
        {
          path: "ssq_excel_fabu",
          meta: { name: "双色球缩水条件发布" },
          component: () =>
            import("@/views/personalCenter/jqs_fabu/ssq_excel_fabu.vue"),
        },
        {
          path: "dlt_excel_fabu",
          meta: { name: "大乐透缩水条件发布" },
          component: () =>
            import("@/views/personalCenter/jqs_fabu/dlt_excel_fabu.vue"),
        },
        {
          path: "fcsd_jqs_fabu",
          meta: { name: "3D技巧师缩水条件发布" },
          component: () =>
            import("@/views/personalCenter/jqs_fabu/fcsd_jqs_excel_fabu.vue"),
        },
        {
          path: "pls_excel_fabu",
          meta: { name: "排三技巧师缩水条件发布" },
          component: () =>
            import("@/views/personalCenter/jqs_fabu/pls_excel_fabu.vue"),
        },
        // {
        //     path: 'fei_excel_chushou',
        //     meta: { name: '非excel缩水技巧买断 出售' },
        //     component: () => import('@/views/personalCenter/jqs_fabu/fei_excel_chushou.vue'),
        // },
        {
          path: "xianzhi_excel_fabu",
          meta: { name: "闲置,定制EXCEL改修申请" },
          component: () =>
            import(
              "@/views/personalCenter/jqs_fabu/xianzhi_excel_edit_apply.vue"
            ),
        },
        // {
        //     path: 'dingzhi_excel_apply',
        //     meta: { name: '定制excel表申请' },
        //     component: () => import('@/views/personalCenter/jqs_fabu/dingzhi_excel_apply.vue'),
        // },
        {
          path: "jqs_zonghe_mx",
          meta: { name: "技巧师综合明细" },
          component: () =>
            import("@/views/personalCenter/jqs_fabu/jqs_zonghe_mx.vue"),
        },
      ],
    },
    {
      path: "suoshuiruanjian",
      meta: { name: "我的缩水软件发布" },
      component: () => import("@/views/personalCenter/content.vue"),
      children: [
        {
          path: "apply_jys",
          meta: { name: "申请软件交易师" },
          component: () =>
            import("@/views/personalCenter/suoshuiruanjian_fabu/apply_jys.vue"),
        },
        // {
        //   path: "fabu_software",
        //   meta: { name: "发布缩水软件" },
        //   component: () =>
        //     import(
        //       "@/views/personalCenter/suoshuiruanjian_fabu/shrinkSoftware/index.vue"
        //     ),
        // },
        // {
        //   path: "apply_youchang_zhuanrang",
        //   meta: { name: "申请有偿转让软件" },
        //   component: () =>
        //     import(
        //       "@/views/personalCenter/suoshuiruanjian_fabu/apply_youchang_zhuanrang.vue"
        //     ),
        // },
        // {
        //   path: "apply_dingzhi_zhongchou",
        //   meta: { name: "申请定制缩水软件（众筹）" },
        //   component: () =>
        //     import(
        //       "@/views/personalCenter/suoshuiruanjian_fabu/apply_dingzhi_zhongchou.vue"
        //     ),
        // },
        // {
        //   path: "ruanjian_zonghe_mx",
        //   meta: { name: "软件综合明细" },
        //   component: () =>
        //     import(
        //       "@/views/personalCenter/suoshuiruanjian_fabu/ruanjian_zonghe_mx.vue"
        //     ),
        // },
        // {
        //   path: "my_publish",
        //   meta: { name: "我发布的" },
        //   component: () =>
        //     import(
        //       "@/views/personalCenter/suoshuiruanjian_fabu/shrinkSoftware/index.vue"
        //     ),
        // },
        // {
        //   path: "my_join",
        //   meta: { name: "我参与的" },
        //   component: () =>
        //     import("@/views/personalCenter/suoshuiruanjian_fabu/shrinkSoftware/index.vue"),
        // },

        {
          path: "shrinkSoftware",
          meta: { name: "我的缩水软件" },
          component: () =>
            import(
              "@/views/personalCenter/suoshuiruanjian_fabu/shrinkSoftware/index.vue"
            ),
        },
        {
          path: "dingzhi_software_need",
          meta: { name: "定制软件需求" },
          component: () =>
            import(
              "@/views/personalCenter/suoshuiruanjian_fabu/dingzhi_software_need/index.vue"
            ),
        },
      ],
    },
    {
      path: "tzz_bf",
      meta: { name: "投注站帮扶中心" },
      component: () => import("@/views/personalCenter/content.vue"),
      children: [
        {
          path: "apply",
          meta: { name: "相关申请" },
          component: () => import("@/views/personalCenter/tzz_bangfu/apply"),
        },
        // {
        //   path: "cp_tzz_sq_bf",
        //   meta: { name: "彩票投注站申请帮扶" },
        //   component: () =>
        //     import("@/views/personalCenter/tzz_bangfu/cp_tzz_sq_bf.vue"),
        // },
        {
          path: "MySchemeList",
          meta: { name: "实战超市方案" },
          component: () =>
            import("@/views/personalCenter/tzz_bangfu/MySchemeList.vue"),
        },
        {
          path: "ManagerApply",
          meta: { name: "发布众筹招股" },
          component: () =>
            import("@/views/personalCenter/tzz_bangfu/ManagerApply.vue"),
        },
        {
          path: "myOffering",
          meta: { name: "我发布的众筹招股" },
          component: () =>
            import("@/views/homePage/menu/sttzzbfzx/dating/myOffering.vue"),
        },
        {
          path: "earnings_record",
          meta: { name: "收益记录" },
          component: () =>
            import("@/views/personalCenter/tzz_bangfu/earnings_record.vue"),
        },
        // {
        //   path: "tzz_szp_syjl",
        //   meta: { name: "实战票及收益记录" },
        //   component: () =>
        //     import("@/views/personalCenter/tzz_bangfu/tzz_szp_syjl.vue"),
        // },
        // {
        //   path: "cp_jl_sq",
        //   meta: { name: "彩票经理/代表申请" },
        //   component: () =>
        //     import("@/views/personalCenter/tzz_bangfu/cp_jl_sq.vue"),
        // },
        // {
        //   path: "cp_jl_gl_syjl",
        //   meta: { name: "彩票经理/代表管理及收益记录" },
        //   component: () =>
        //     import("@/views/personalCenter/tzz_bangfu/cp_jl_gl_syjl.vue"),
        // },
        // {
        //   path: "zy_kh_zc_djjl",
        //   meta: { name: "自由客户众筹及兑奖记录" },
        //   component: () =>
        //     import("@/views/personalCenter/tzz_bangfu/zy_kh_zc_djjl.vue"),
        // },
      ],
    },

    {
      path: "help",
      meta: { name: "帮助中心" },
      component: () => import("@/views/personalCenter/content.vue"),
      children: [
        {
          path: "help",
          meta: { name: "帮助中心" },
          component: () => import("@/views/personalCenter/help/help.vue"),
        },
      ],
    },
  ],
};
